<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :sm="12" :md="8" :xl="4">
                    <el-input v-model="params.queryValue" class="input-with-select" size="small">
                        <el-select v-model="params.queryType" slot="prepend" placeholder="请选择">
                            <el-option label="事件名称" :value="1"></el-option>
                            <el-option label="事件标识" :value="2"></el-option>
                            <el-option label="事件ID" :value="3"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :sm="12" :md="8" :xl="4">
                    <el-select v-model="params.actionType" placeholder="请选择" size="small">
                        <el-option label="不限制动行为类型" value=""></el-option>
                        <el-option v-for="item in actionTypeList" :label="item.label" :key="item.value" :value="item.label"></el-option>
                    </el-select>
                </el-col>
                <el-col :sm="12" :md="8" :xl="4">
                    <el-select v-model="params.isOnline" placeholder="请选择" size="small">
                        <el-option label="不限制动是否上线" value=""></el-option>
                        <el-option label="仅看已上线的 " :value="1"></el-option>
                        <el-option label="仅看未上线的" :value="0"></el-option>
                    </el-select>
                </el-col>
                <el-col :sm="12" :md="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/eventManage/save')" type="primary" size="small" @click="$refs.edit.show()">新增事件</el-button>
            <el-button v-if="$utils.have('/event/conversionRate/list')" type="primary" size="small" @click="$router.push('/eventManage/conversionRate/list')">事件转化率</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="id" label="事件ID"></el-table-column>
                <el-table-column prop="eventId" label="事件标识" show-overflow-tooltip></el-table-column>
                <el-table-column prop="eventName" label="事件名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="actionType" label="行为类型" >
                    <!-- <template slot-scope="{row} = scope">
                        {{ actionTypeList.find(item => item.value == row.actionType).label }}
                    </template> -->
                </el-table-column>
                <el-table-column prop="isOnline" label="是否上线" >
                    <template slot-scope="{row} = scope">
                        <el-tag v-if="row.isOnline == 1" size="mini" type="success">已上线</el-tag>
                        <el-tag v-else size="mini" type="info">未上线</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" min-width="150">
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="{row} = scope">
                        <el-button
                            v-if="$utils.have('/eventManage/save')"
                            type="text"
                            size="small"
                            @click="$refs.edit.show(row)"
                            >编辑</el-button
                        >
                        <el-button
                            v-if="$utils.have('/eventManage/statistics')"
                            type="text"
                            size="small"
                            @click="statistic(row.id)"
                            >数据统计</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <edit ref="edit" :actionTypeList="actionTypeList" @onUpdate="getDataList"></edit>
    </div>
</template>
<script>
import Edit from './components/Edit.vue';
const defaultParams = {
    pageNo:1,
    actionType:'',
    isOnline: '',
    queryType: 1,
    queryValue: '',
}
export default {
    components:{
        Edit
    },
    data() {
        return {
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                actionType: this.$route.query.actionType ? parseInt(this.$route.query.actionType) : '',
                isOnline: this.$route.query.isOnline ? parseInt(this.$route.query.isOnline) : '',
                queryType: parseInt(this.$route.query.queryType || 1),
                queryValue: this.$route.query.queryValue ?? '',
            },
            listLoading: true,
            actionTypeList: [{
                value: 0,
                label: '点击'
            }, {
                value: 1,
                label: '滑动'
            }, {
                value: 2,
                label: '长按'
            }, {
                value: 3,
                label: '拖动'
            }, {
                value: 4,
                label: '曝光'
            }]
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/eventManage/list",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
				} else {
                    this.data = null;
					this.dataList = [];
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
         //选择pageSize
         handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //统计
        statistic(id) {
            this.$router.push({
                path: `/eventManage/list/statistic/${id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        {
                            ...this.params,
                        }
                    ),
                },
            })
        }
    }
}
</script>
<style lang="scss" scoped>

</style>